import { useQuery } from '@tanstack/react-query'
import { useApi } from '@tabeeb/modules/shared/utils/API'

import { ArticlesQueryKeys } from '../queries'

export interface UseTrainingMaterialProps {
  id?: number
  onError?: (error: unknown) => void
  onMarkedAsRead?: () => void
}

export const useTrainingMaterial = ({ id, onMarkedAsRead, onError }: UseTrainingMaterialProps) => {
  const { articleServiceApi: api } = useApi()

  const query = useQuery({
    queryKey: [ArticlesQueryKeys.TrainingMaterial, id],
    queryFn: () => api.trainingMaterials.getAsync(id!),
    enabled: !!id,
    onError,
  })

  return {
    loading: query.isLoading,
    trainingMaterial: query.data,
    onReload: query.refetch,
  }
}

export default useTrainingMaterial
